const Followers = Object.freeze({
  FOLLOWERS_0: 'Followers_0',
  FOLLOWERS_10: 'Followers_10',
  FOLLOWERS_50: 'Followers_50',
  FOLLOWERS_100: 'Followers_100',
  FOLLOWERS_500: 'Followers_500',
  FOLLOWERS_1K: 'Followers_1K',
  FOLLOWERS_5K: 'Followers_5K',
  FOLLOWERS_10K: 'Followers_10K',
  FOLLOWERS_50K: 'Followers_50K',
  FOLLOWERS_100K: 'Followers_100K',
  FOLLOWERS_500K: 'Followers_500K',
  FOLLOWERS_1M: 'Followers_1M',
  FOLLOWERS_5M: 'Followers_5M',
  FOLLOWERS_10M: 'Followers_10M',
  FOLLOWERS_50M: 'Followers_50M',
  FOLLOWERS_100M: 'Followers_100M',
  FOLLOWERS_NO_LIMIT: 'Followers_NO_LIMIT'
})
export default Followers
export type FollowersStrings = typeof Followers[keyof typeof Followers]
// RESERVE BELOW
